import React from "react";
import type { NLQueryResult } from "hooks/useNLQuery";
import AgenticBarChart from "./AgenticBarChart";
import AgenticLineChart from "./AgenticLineChart";
import AgenticPieChart from "./AgenticPieChart";
import AgenticScatterChart from "./AgenticScatterChart";
import AgenticMetricCard from "./AgenticMetricCard";

interface Props {
  result: NLQueryResult;
}

const AgenticChartRenderer: React.FC<Props> = ({ result }) => {
  const { visualization, rows, columns } = result;

  if (!visualization || !rows || rows.length === 0) return null;

  const vizType = visualization.type;

  if (vizType === "table") return null;

  const chartProps = { rows, columns, visualization, loading: false };

  switch (vizType) {
    case "bar":
    case "grouped_bar":
      return <AgenticBarChart {...chartProps} />;
    case "line":
      return <AgenticLineChart {...chartProps} />;
    case "pie":
      return <AgenticPieChart {...chartProps} />;
    case "scatter":
      return <AgenticScatterChart {...chartProps} />;
    case "metric_card":
      return <AgenticMetricCard {...chartProps} />;
    default:
      return null;
  }
};

export default AgenticChartRenderer;
